import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\ReportStreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/ReportStreetViewController.php:17
* @route '/internal-api/report/{report}/street-view'
*/
export const update = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/internal-api/report/{report}/street-view',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Api\Internal\ReportStreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/ReportStreetViewController.php:17
* @route '/internal-api/report/{report}/street-view'
*/
update.url = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return update.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\ReportStreetViewController::__invoke
* @see app/Http/Controllers/Api/Internal/ReportStreetViewController.php:17
* @route '/internal-api/report/{report}/street-view'
*/
update.put = (args: { report: string | { id: string } } | [report: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const streetView = {
    update: Object.assign(update, update),
}

export default streetView